import PropTypes from "prop-types";
import { formatMoney } from "./../libs/formatNumber"

export const renderGridMoneyColumn = (rowData, col,) => {
  const {
    currency = '$',
    decimalPlaces = 2,
    thousandSeparator = ',',
    decimalSeparator = '.'
  } = col.colSettings || {};


  const dateValue = rowData?.[col.fieldName]
  return (
    formatMoney(dateValue, currency, decimalPlaces, thousandSeparator, decimalSeparator)
  );
};

renderGridMoneyColumn.propTypes = {
  rowData: PropTypes.object.isRequired,
  col: PropTypes.shape({
    fieldName: PropTypes.string.isRequired,
    colSettings: PropTypes.shape({
      currency: PropTypes.string,
      decimalPlaces: PropTypes.number,
      thousandSeparator: PropTypes.string,
      decimalSeparator: PropTypes.string,
    }),
  }).isRequired,
};